const getters = {
  token: state => state.user.token,
  id: state => state.user.id,
  name: state => state.user.name,
  username: state => state.user.username,
  userType: state => state.user.userType,
  departId: state => state.user.departId,
  departName: state => state.user.departName,
  departs: state => state.user.departs,
  introduction: state => state.user.introduction,
  errorLogs: state => state.errorLog.logs,
  dicts: state => state.user.dicts,
  multiLanguage: state => state.user.multiLanguage,
  taskId: state => state.workflow.taskId,
  businessKey: state => state.workflow.businessKey,
  taskDefinitionKey: state => state.workflow.taskDefinitionKey
}
export default getters
